import BaseView from './view';

var BaseComponent = BaseView.extend({
    template: '<span>Your need extend base component</span>',
    initialize: function(options = {}) {
        this.beforeInitialize(options);
        this.cId = options.id;
        this.uId = options.uId || '';
        this.cName = options.name;
        this.components = options.components;
        this.data = options;
        this.$parent = this.$el.parents('#jsc' + this.data.parentName + this.data.parentId);
        this.render();
        this.afterInitialize(options)
    },
    getContext: function(context) {
        var parent = {
            'parent-uId': this.uId || '',
            'parent-name': this.name || ''
        }, result;

        result = BaseView.prototype.getContext.apply(this, arguments);
        result.push(this.data);
        result.push(parent);
        return result;
    },
    trigger: function(type, extraData={}) {
        var event = {
            type: type || this.cName,
            extra: extraData,
            actorTarget: this
        }

        this.$el.trigger(event);
    }
});

export default BaseComponent;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/base/component.js